var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[(!_vm.scan)?_c('report-top'):_vm._e(),_vm._v(" "),_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.tableData,"no-data-text":"<div class='table-no-data'></div>","height":_vm.utils.setTableHeight(200)},on:{"on-selection-change":function($event){_vm.selectData = $event}},scopedSlots:_vm._u([{key:"imgs",fn:function(ref){
var row = ref.row;
return [_c('imgList',{attrs:{"data":row.filesPathList}})]}},{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Button',{attrs:{"size":"small"},on:{"click":function($event){return _vm.downLoad(row, index)}}},[_vm._v("下载文件")])]}}])}),_vm._v("\n\n  d>\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45b25a01","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/event/word.vue
// module id = null
// module chunks = 